"use strict";
/**
 * This file has been generated
 * DO NOT EDIT, IT MAY BE OVERWRITTEN
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var abstract_service_1 = require("../abstract-service");
var LoraService = /** @class */ (function (_super) {
    __extends(LoraService, _super);
    function LoraService(client, apiConfig) {
        var _this = _super.call(this, client, apiConfig) || this;
        _this.resources = {
            'getConfig': {
                path: "/lora/config",
                methodType: "GET",
                returnTypeConverter: "LoraConfig"
            },
            'getIds': {
                path: "/lora/ids",
                methodType: "GET",
                returnTypeConverter: "Bytes"
            },
            'putConfig': {
                path: "/lora/config",
                methodType: "PUT",
                bodyEncoder: "LoraConfig"
            },
            'putIds': {
                path: "/lora/ids",
                methodType: "PUT",
                bodyEncoder: "Bytes"
            },
        };
        return _this;
    }
    /**
    * Get LoRa configuration
    * LoRa IDs to connect to gateway (b0-7 : DevEui, b8-15 : AppEui, b16_31 : AppKey)
    * LWM2M path: /1024//91
    * @tapVersion(">=1.0")
    * @return LoraConfig api call
    */
    LoraService.prototype.getConfig = function () {
        var callOptions = this.getConfigCall();
        return this._call(callOptions);
    };
    /**
    * Get LoRa configuration
    * LoRa IDs to connect to gateway (b0-7 : DevEui, b8-15 : AppEui, b16_31 : AppKey)
    * LWM2M path: /1024//91
    * @tapVersion(">=1.0")
    * @return call options
    */
    LoraService.prototype.getConfigCall = function () {
        var callOptions = this.resources.getConfig;
        return callOptions;
    };
    /**
    * Get LoRa IDs
    * LoRa IDs to connect to gateway (b0-7 : DevEui, b8-15 : AppEui, b16_31 : AppKey)
    * LWM2M path: /1024//90
    * @tapVersion(">=1.0")
    * @return Uint8Array api call
    */
    LoraService.prototype.getIds = function () {
        var callOptions = this.getIdsCall();
        return this._call(callOptions);
    };
    /**
    * Get LoRa IDs
    * LoRa IDs to connect to gateway (b0-7 : DevEui, b8-15 : AppEui, b16_31 : AppKey)
    * LWM2M path: /1024//90
    * @tapVersion(">=1.0")
    * @return call options
    */
    LoraService.prototype.getIdsCall = function () {
        var callOptions = this.resources.getIds;
        return callOptions;
    };
    /**
    * Write LoRa configuration
    *
    * LWM2M path: /1024//91
    * Body converter id: "LoraConfig"
    * @tapVersion(">=1.0")
    * @param value input
    * @return void api call
    */
    LoraService.prototype.putConfig = function (value) {
        var callOptions = this.putConfigCall(value);
        return this._call(callOptions);
    };
    /**
    * Write LoRa configuration
    *
    * LWM2M path: /1024//91
    * Body converter id: "LoraConfig"
    * @tapVersion(">=1.0")
    * @param value input
    * @return call options
    */
    LoraService.prototype.putConfigCall = function (value) {
        var callOptions = this.resources.putConfig;
        callOptions.body = value;
        callOptions.pathParameters = {};
        return callOptions;
    };
    /**
    * Write LoRa IDs
    *
    * LWM2M path: /1024//90
    * Body converter id: "Bytes"
    * @tapVersion(">=1.0")
    * @param value input
    * @return void api call
    */
    LoraService.prototype.putIds = function (value) {
        var callOptions = this.putIdsCall(value);
        return this._call(callOptions);
    };
    /**
    * Write LoRa IDs
    *
    * LWM2M path: /1024//90
    * Body converter id: "Bytes"
    * @tapVersion(">=1.0")
    * @param value input
    * @return call options
    */
    LoraService.prototype.putIdsCall = function (value) {
        var callOptions = this.resources.putIds;
        callOptions.body = value;
        callOptions.pathParameters = {};
        return callOptions;
    };
    return LoraService;
}(abstract_service_1.AbstractService));
exports.LoraService = LoraService;
